


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Message extends Vue {
  @Prop({ type: Boolean, default: false })
  readonly bottom!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly color!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly closeBlock!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly textCenter!: boolean;

  @Prop({ type: Boolean, default: false })
  readonly bold!: boolean;

  get classes() {
    const { bottom, color, textCenter, bold } = this;
    const result: Array<string> = [];
    if (bottom) result.push('message_bottom');
    if (color) result.push('message_red');
    if (textCenter) result.push('message_center');
    if (bold) result.push('message_bold');
    return result;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/components/info/compopnents/block/components/resultform/components/message/Message.vue